<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
            <v-col cols="12" md="12" class="timetracking-part d-flex align-center justify-center flex-column">
              <div class="timetracking-wrapper pt-16 pt-sm-0">
                    <v-form>
                      <v-container>
                        <v-row class="flex-column">
                          <v-col>
                          <div class="d-flex justify-center" justify="center">
                            <v-img src="@/assets/tradexc_vertical_logo.png" contain max-width="200" min-width="100"></v-img>
                          </div>
                          </v-col>
                          <v-form
                            ref="log"
                            v-model="valid"
                            lazy-validation
                          >
                            <v-col>
                              <div class="d-flex justify-center" justify="center">
                              <video v-show="!isPhotoTaken" id="camera" ref="camera" width="160" height="120" autoplay></video>
                              <canvas v-show="isPhotoTaken" id="canvas" ref="canvas" width="160" height="120"></canvas>
                              <img src="">
                              <canvas style="display:none;"></canvas>
                              </div>
                              <v-text-field
                                dense
                                light
                                height="50"
                                id="email"
                                ref="email"
                                v-model="email"
                                :rules="emailRules"
                                single-line
                                value=""
                                label="Email Address"
                                required
                              ></v-text-field>
                              <v-text-field
                                dense
                                light
                                height="50"
                                id="password"
                                ref="password"
                                v-model="password"
                                :rules="passRules"
                                single-line
                                type="password"
                                label="Employee Pin"
                                required
                              ></v-text-field>
                              <v-text-field
                                class="centered-input"
                                readonly
                                dense
                                light
                                height="50"
                                id="datetime"
                                ref="datetime"
                                v-model="datetime"
                                single-line
                                label="Date Time"
                                required
                              ></v-text-field>
                              <v-text-field
                                class="centered-input"
                                dense
                                readonly
                                light
                                height="50"
                                id="geolocation"
                                ref="geolocaion"
                                v-model="geolocation"
                                single-line
                                label="Geolocation"
                                required
                              ></v-text-field>
                              <div class="d-flex justify-center" justify="center">
                              <v-switch
                                v-model="timetype"
                                color="primary"
                                v-bind:label="timetype"
                                v-on:change="setType"
                                value="Time In"
                              ></v-switch>
                              </div>
                            </v-col>
                            <v-col class="d-flex justify-space-between">
                              <v-btn
                                class="text-capitalize"
                                light
                                large
                                block
                                :disabled="password.length === 0 || email.length === 0"
                                color="primary"
                                :loading="isFetching"
                                @click="submitTimeTracking"
                                v-show="!isDone">
                                Submit Time
                              </v-btn>
                              <v-btn
                                class="text-capitalize"
                                light
                                large
                                block
                                color='green'
                                v-show="isDone"
                                @click="done"
                                >
                                Done
                              </v-btn>
                            </v-col>
                            <v-row>
                            <v-col class="d-flex justify-center">
                              <v-btn
                                to="/login"
                                small
                                text
                                class="text-capitalize primary--text"
                                >
                                Login Page
                              </v-btn>
                            </v-col>
                            </v-row>
                          </v-form>
                        </v-row>
                      </v-container>
                    </v-form>
              </div>
            </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="alert"
      color="blue">
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="alert = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'TimeTracking',
  data() {
    return {
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading: false,
      video: undefined,
      email: '',
      timetracking: {},
      datetime: '',
      geolocation: '',
      cameraimage: undefined,
      timetype: undefined,
      valid: true,


      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
        v => v.toLowerCase() === this.email
      ],
      password: '',
      passRules: [
        v => !!v || 'Pin is required',
        v => v.length >= 6 || 'Min 6 characters'
      ],
      alert: false,
      message: ''
    }
  },
  methods: {
    ...mapActions('TimeTracking', ['createTimeTracking', 'receiveTimeTracking', 'endTimeTracking']),
    done(){
      this.endTimeTracking();
      
    },
    submitTimeTracking(){
      this.takeCameraPhoto(file=>{
        const d = new Date();
        const timetracking = {
          timetype: this.timetype,
          employeeemail: this.email,
          employeepin: this.password,
          datetime: null,
          geolocation:  this.geolocation,
          image: file,
          imagename: d.getTime().toString() + '.png',
        };
        this.createTimeTracking(timetracking);
      });
      
    },
    setType(event){
      if(event==null) this.timetype = 'Time Out';
    },
    createCamera() {
      this.isLoading = true;
      
      const constraints = {
				audio: false,
				video: true,
        width: { min: 160, ideal: 160, max: 160 },
        height: { min: 120, ideal: 120 },
        aspectRation: 1.33,
        facingMode: { exact: "user" }
			};


			navigator.mediaDevices
				.getUserMedia(constraints)
				.then(stream => {
          this.isLoading = false;
					this.$refs.camera.srcObject = stream;
				})
				.catch(error => {
          this.isLoading = false;
					alert(error);
				});
    },
    stopCamera() {
      let tracks = this.$refs.camera.srcObject.getTracks();

			tracks.forEach(track => {
				track.stop();
			});
    },
    getDateTime(){
      var D = new Date();
      var y = D.getFullYear();
      var m = D.getMonth()+1;
      var d = D.getDate();
      var t = D.toLocaleTimeString();
      this.datetime = y + '-' + m + '-' + d + ' ' + t;
    },
    getType(){
      var D = new Date();
      var t = D.getHours();
      if(t >= 6 && t < 13) {this.timetype = "Time In"}
      else this.timetype = "Time Out";
    },
    getGeolocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position=>{
          this.geolocation = position.coords.latitude.toFixed(8) + ', ' + position.coords.longitude.toFixed(8);
        });
      } else {
        this.getlocation = "";
      }
    },

    takeCameraPhoto(callback) {
      if(!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }
      
      this.isPhotoTaken = !this.isPhotoTaken;
      
      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 160, 120);

      var canvas = document.getElementById('canvas');
      canvas.toBlob((blob)=> {
        callback(blob);
      });
    },
  },
  computed: {
    ...mapState('TimeTracking', {
      isDone: state => state.isDone,
      isFetching: state => state.isFetching,
      hasAlert: state => state.hasAlert,
      errorMessage: state => state.errorMessage
    } ),
  },

  watch: {
    errorMessage() {
      this.message = this.errorMessage;
      this.alert = this.hasAlert;
    },
    regErrorMessage() {
      this.message = this.regErrorMessage;
      this.alert = true;
    }
  },
  mounted(){
    this.getGeolocation();
    this.getType();
  },
  created() {
    this.getDateTime();
    setInterval(()=>{
      this.getDateTime();
    }, 1000);
    
    this.createCamera();
  },
  beforeDestroy(){
    this.stopCamera();
  }
}

</script>

<style src="./TimeTracking.scss" lang="scss"/>
